import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({
	currentUser: state.session.currentUser,
});

export function withCurrentUser(Component: React.ComponentType<any>) {
	return connect(mapStateToProps)(Component);
}
